import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { LEGEND_COLORS } from "@/dashboard/constants";

interface LegendLabelProps {
  label: string;
  type: keyof typeof LEGEND_COLORS;
}

export const LegendLabel = ({ label, type }: LegendLabelProps) => (
  <Stack direction="row" align="center" gap="sm" className="whitespace-nowrap">
    <div className={`h-3 w-6 rounded-md ${LEGEND_COLORS[type]}`} />
    <Typography variant="captionW1" textColor="tertiary">
      {label}
    </Typography>
  </Stack>
);
